import { Link } from "react-router-dom";
import { services } from "@/mocks/services";
import SectionHeading from "@/components/base/SectionHeading";

export default function ServicesSection() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="Services"
        title="传媒服务"
        desc="从内容制作到宣传发行，星光传媒为影视项目与品牌客户提供全链路的内容服务。"
        action={
          <Link
            to="/about"
            className="hidden items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600 sm:inline-flex"
          >
            了解服务详情
            <i className="ri-arrow-right-line" />
          </Link>
        }
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
        {services.map((service, idx) => (
          <article
            key={service.id}
            className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300"
          >
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary-50 text-primary-600 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
              <i className={`${service.icon} text-2xl`} />
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-950">
              {service.title}
            </h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
              {service.desc}
            </p>
            <div className="mt-4 flex flex-wrap gap-1.5">
              {service.features.map((feature) => (
                <span
                  key={feature}
                  className="rounded bg-secondary-100 px-2 py-0.5 text-xs text-secondary-700"
                >
                  {feature}
                </span>
              ))}
            </div>
            <span className="mt-4 text-xs font-medium tabular-nums text-foreground-300">
              0{idx + 1}
            </span>
          </article>
        ))}
      </div>
    </section>
  );
}